// import logger from '@obseed/logger';
import { logger } from '@app/utils/logger';
import { SafeParseError, SafeParseSuccess, ZodSchema, z } from 'zod';

/**
 * @description
 * @param zod_schema<ZodSchema>
 * @param payload<unknown>
 */
export function validateAgainstSchema<CurrentType extends ZodSchema>(
  zod_schema: CurrentType,
  payload: unknown,
  options: {
    contextName: string;
  }
) {
  return new Promise<z.infer<CurrentType>>((resolve, reject) => {
    try {
      const result = zod_schema.safeParse(payload);

      const { error } = result as SafeParseError<typeof payload>;

      if (error) {
        logger.error({
          msg: `Unable to validate request with schema due to ZodValidationError\ncontextName: ${options.contextName}`,
          data: result,
          error: error.issues,
          // payload,
        });

        reject(new Error('Schema validation failed'));
      } else {
        const resultData = result as SafeParseSuccess<CurrentType>;
        resolve(resultData.data);
      }
    } catch (error) {
      logger.error({
        msg: `Unable to validate request with schema due to unexpected error\ncontextName: ${options.contextName}`,
        error,
        // payload,
      });
      console.log({ error, zod_schema });
      reject(error instanceof Error ? error : new Error('Schema validation failed'));
    }
  });
}
